import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="datadict";
export function selectAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectOne(parameter){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/${parameter}`,
    method: 'get',
  })
}


export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}


export function deleteObj(ids){
  console.log("ids",ids)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params:ids,
    paramsSerializer: params => {
      let result = qs.stringify(params, { indices: false })
      return result;
    }
  })
}

export function selectAllDatadict(){
  return axios({
    url: `/ws/${moduleName}/selectAllDatadict`,
    method: 'get'
  })
}


export function getDatadictChildsByPath(path){
  console.log("wordKey:",path)
  return axios({
    url: `/ws/${moduleName}/getDatadictChildsByPath/${path}`,
    method: 'get',
  })
}


export function getDatadictChildsMapByPath(path){
  console.log("wordKey:",path)
  return axios({
    url: `/ws/${moduleName}/getDatadictChildsMapByPath/${path}`,
    method: 'get',
  })
}

export function getInductionDatadic(pathMap){
  return axios({
    url: `/ws/${moduleName}/getInductionDatadic`,
    method: 'get',
    params:pathMap,
  })
}


export function findCascadingData(path,num,city){
  return axios({
    url: `/ws/${moduleName}/findCascadingData/${path}/${num}/${city}`,
    method: 'get',
  })
}


export function findDataByCity(path,city){
  return axios({
    url: `/ws/${moduleName}/findDataByCity/${path}/${city}`,
    method: 'get',
  })
}

export default {
  selectOne,
  selectAll,
  insert,
  update,
  deleteObj,
  selectAllDatadict,
  getDatadictChildsByPath,
  getDatadictChildsMapByPath,
  getInductionDatadic,
  findCascadingData,
  findDataByCity
}